import { createSelector } from 'reselect';
import { pdpVideoIconSelector } from 'selectors/testTarget/offers/pdpVideoIcon/pdpVideoIconSelector';

const showSelector = createSelector(pdpVideoIconSelector, pdpVideoIcon => !!pdpVideoIcon.active);

export { showSelector };
